// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3PysY","m4":"style_m4__1MZDo","linkstyle":"style_linkstyle__2QlY9"};